
import React from 'react';
import { Neighborhood, Category } from '../types';

interface FilterBarProps {
  neighborhoods: Neighborhood[];
  categories: Category[];
  selectedCategory: string | null;
  selectedNeighborhood: string | null;
  searchTerm: string;
  verifiedOnly: boolean;
  onCategoryChange: (id: string | null) => void;
  onNeighborhoodChange: (id: string | null) => void;
  onSearchChange: (term: string) => void;
  onVerifiedOnlyChange: (active: boolean) => void;
}

const FilterBar: React.FC<FilterBarProps> = ({
  neighborhoods,
  categories,
  selectedCategory,
  selectedNeighborhood,
  searchTerm,
  verifiedOnly,
  onCategoryChange,
  onNeighborhoodChange,
  onSearchChange,
  onVerifiedOnlyChange,
}) => {
  return (
    <div className="bg-white rounded-[2rem] shadow-xl p-6 mb-8 border border-gray-100 animate-in fade-in slide-in-from-top-4 duration-500">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
        {/* Busca por Texto */}
        <div className="relative md:col-span-1">
          <input
            type="text"
            placeholder="O que você busca hoje?"
            className="w-full pl-12 pr-4 py-4 rounded-2xl text-sm font-medium border-none bg-inputGray focus:ring-2 focus:ring-brand-orange"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
          />
          <svg className="w-5 h-5 absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </div>

        {/* Filtro de Bairro */}
        <div className="relative">
          <select
            className="w-full pl-12 pr-4 py-4 rounded-2xl text-sm font-bold uppercase tracking-widest border-none bg-inputGray appearance-none focus:ring-2 focus:ring-brand-orange text-navy"
            value={selectedNeighborhood || ''}
            onChange={(e) => onNeighborhoodChange(e.target.value || null)}
          >
            <option value="">📍 Todos os Bairros</option>
            {neighborhoods.map((n) => (
              <option key={n.id} value={n.id}>
                📍 {n.name}
              </option>
            ))}
          </select>
          <div className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
             <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
          </div>
        </div>

        {/* Filtro de Categoria */}
        <div className="relative">
          <select
            className="w-full pl-12 pr-4 py-4 rounded-2xl text-sm font-bold uppercase tracking-widest border-none bg-inputGray appearance-none focus:ring-2 focus:ring-brand-orange text-navy"
            value={selectedCategory || ''}
            onChange={(e) => onCategoryChange(e.target.value || null)}
          >
            <option value="">🏷️ Categorias</option>
            {categories.map((c) => (
              <option key={c.id} value={c.id}>
                {c.icon || '📁'} {c.name}
              </option>
            ))}
          </select>
          <div className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7" /></svg>
          </div>
        </div>

        {/* Switch de Verificados (UX Boost) */}
        <div 
          onClick={() => onVerifiedOnlyChange(!verifiedOnly)}
          className={`flex items-center gap-3 p-3 rounded-2xl cursor-pointer transition-all border-2 ${verifiedOnly ? 'bg-brand-orange/10 border-brand-orange' : 'bg-inputGray border-transparent'}`}
        >
          <div className={`w-10 h-6 rounded-full relative transition-colors ${verifiedOnly ? 'bg-brand-orange' : 'bg-gray-300'}`}>
            <div className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-all ${verifiedOnly ? 'left-5' : 'left-1'}`} />
          </div>
          <div className="flex flex-col">
            <span className="text-[9px] font-black uppercase tracking-widest text-brand-navy leading-none">Apenas Verificados</span>
            <span className="text-[7px] font-bold uppercase text-gray-400 mt-1">Garantia de Confiança</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterBar;
